export const GlobalCancellationsDelays = {
  top: {
    id: 'div-gpt-ad-1503353720593-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_GlobalCancellationsDelays_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1503353720593-1',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_GlobalCancellationsDelays_top_320x100',
  },
};



// WEBPACK FOOTER //
// ./modules/GlobalCancellationsDelays/components/ads.js